'use client';

import React, { useState, useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useCity } from '../../../context/cityContext';
import { CitySelectorProps } from '../types';
import { cn } from '@/lib/utils';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

export const CitySelector: React.FC<CitySelectorProps> = ({ className, disabled = false }) => {
  const { selectedCity, setSelectedCity, isInitialized } = useCity();
  const [isChangingCity, setIsChangingCity] = useState(false);
  const t = useTranslations('Header');

  const handleCityChange = useCallback(
    (value: string) => {
      setIsChangingCity(true);
      setSelectedCity(value as any);
      // Simulate a small delay for user feedback
      setTimeout(() => {
        setIsChangingCity(false);
      }, 500);
    },
    [setSelectedCity],
  );

  return (
    <div className={cn('relative', className)}>
      <Select
        value={selectedCity}
        onValueChange={handleCityChange}
        disabled={disabled || isChangingCity || !isInitialized}
      >
        <SelectTrigger className='w-[180px] text-white'>
          <SelectValue placeholder={t('selectCity')} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='all'>{t('allCities')}</SelectItem>
          <SelectItem value='Caracas'>{t('cities.caracas')}</SelectItem>
          <SelectItem value='Barcelona'>{t('cities.barcelona')}</SelectItem>
          <SelectItem value='Miami'>{t('cities.miami')}</SelectItem>
          <SelectItem value='Bogotá'>{t('cities.bogota')}</SelectItem>
          <SelectItem value='Santiago'>{t('cities.tokio')}</SelectItem>
          <SelectItem value='Buenos Aires'>{t('cities.buenosaires')}</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
